// La app se mantiene en la última versión sola (problema del 19/10/2026: una
// pestaña abierta varios días siguió usando una Colonia vieja).
//
// Cada versión publicada tiene su archivo index-<hash>.js. Cada tanto, y al
// cambiar de pantalla, se pide index.html sin caché y se compara: si el
// archivo cambió, hay versión nueva. Entonces:
//   · se muestra un aviso con "Recargar ahora";
//   · y al próximo cambio de pantalla se recarga sola (ahí no hay ningún
//     formulario a medio llenar que se pierda).
//
// En desarrollo (vite dev) no hay archivo con hash: no hace nada.

const CADA_MS = 5 * 60 * 1000;

function versionActual() {
  const script = document.querySelector('script[type="module"][src*="/assets/index-"]');
  return script?.getAttribute("src") ?? null;
}

async function versionPublicada() {
  try {
    const res = await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const html = await res.text();
    return html.match(/src="(\/assets\/index-[^"]+\.js)"/)?.[1] ?? null;
  } catch {
    return null; // sin conexión: se vuelve a probar más tarde
  }
}

let hayNueva = false;

function mostrarAviso() {
  if (document.getElementById("version-nueva")) return;
  const aviso = document.createElement("div");
  aviso.id = "version-nueva";
  aviso.className = "version-nueva";
  aviso.setAttribute("role", "status");
  aviso.innerHTML = `
    <span>Hay una versión nueva de la app.</span>
    <button type="button" class="btn">Recargar ahora</button>`;
  aviso.querySelector("button").addEventListener("click", () => window.location.reload());
  document.body.appendChild(aviso);
}

async function revisar() {
  const actual = versionActual();
  if (!actual || hayNueva) return;
  const publicada = await versionPublicada();
  if (publicada && publicada !== actual) {
    hayNueva = true;
    mostrarAviso();
  }
}

/** Arranca la revisión periódica. Llamar una vez al iniciar la app. */
export function vigilarVersion() {
  if (!versionActual()) return;
  setInterval(revisar, CADA_MS);
  // Al volver a la pestaña después de un rato (el caso del 19/10).
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") revisar();
  });
}

/**
 * Al cambiar de pantalla: si ya se sabe que hay versión nueva, recarga y
 * devuelve true (la pantalla no se dibuja con la versión vieja). Si no,
 * revisa en segundo plano para la próxima.
 */
export function recargarSiHayNueva() {
  if (hayNueva) {
    window.location.reload();
    return true;
  }
  revisar();
  return false;
}
